const load = {
    1: 'rechargeOrderExport', // 充值订单导出
    2: 'productOrderReduceRecordExport', // 缩减订单导出
    3: 'productOrderExport', // 购买订单导出
    4: 'depositExport', // 定金导出
    5: 'signedTimeTableExport', // 课签导出
    6: 'refundExport', // 退费列表导出
    7: 'productOrderEnrollmentIndexExport', // 自招产品购买分配导出
    8: 'refundEnrollmentIndexExport', // 自招产品退费记录列表导出
    9: 'teacherRefundExport', // 退费教师退费分解列表导出
    10: 'teacherResolveExport', // 退费教师续费分解列表导出
    11: 'taskTotalExport', // 线路任务总表导出
    12: 'taskPersonExport', // 部门个人月度任务导出

    13: 'communityStatisByBranchExport', // 社群-分公司统计导出
    14: 'communityStatisByPersonExport', // 社群-个人统计导出
    15: 'communityStatisByDepmentExport', // 社群-部门统计导出

    16: 'crmStatisSchoolByDayExport', // 校区日统计导出
    17: 'crmStatisSchoolByWeekExport', // 校区周统计导出
    18: 'crmStatisSchoolByMonthExport', // 校区月统计导出
    19: 'crmStatisBranchByDayExport', // 分公司日统计导出
    20: 'crmStatisBranchByWeekExport', // 分公司周统计导出
    21: 'crmStatisBranchByMonthExport', // 分公司月统计导出
    22: 'crmStatisMarketProductByDayExport', // 营销产品日统计导出
    23: 'crmStatisMarketProductByWeekExport', // 营销产品周统计导出
    24: 'crmStatisMarketProductByMonthExport', // 营销产品月统计导出
    25: 'crmStatisGradeByDayExport', // 年级日统计导出
    26: 'crmStatisGradeByWeekExport', // 年级周统计导出
    27: 'crmStatisGradeByMonthExport', // 年级月统计导出
    28: 'crmStatisDepartmentByDayExport', // 部门日统计导出
    29: 'crmStatisDepartmentByWeekExport', // 部门周统计导出
    30: 'crmStatisDepartmentByMonthExport', // 部门月统计导出

    31: 'contractTypeExport', // 合同类型统计导出
    32: 'advanceCollectExport', // 预收汇总统计导出
    33: 'enrollmentExport', // 自主招生财务汇总统计导出
    34: 'statRefundExport', // 退费汇总表统计导出

    35: 'teacherExport', // 教师1对1课时统计导出
    36: 'teacherClassExport', // 教师班组课时统计导出
    37: 'subjectGroupExport', // 学科组课时收入统计导出
    38: 'schoolSignExport', // 校区签单统计（前后期）统计导出
    39: 'managementExport', // 学管1对1课时统计统计导出
    40: 'managementClassExport', // 学管班组课时统计导出

    41: 'monthStatisTeacherGradeSubjectByMonthExport', // 教师年级科目统计导出
    42: 'monthStatisSchoolClassTypeReceiveByMonthExport', // 校区班型课收统计导出
    43: 'monthStatisSchoolTasksByMonthExport', // 校区课签统计导出
    44: 'monthStatisTeacherClassSignNumberByMonthExport', // 教师课时量综合统计导出
    45: 'monthStatisSchoolTeacherRemainByMonthExport', // 校区教师留存统计导出
    46: 'monthStatisSchoolClassCoefficientByMonthExport', // 校区课时系数导出

    47: 'preSchoolPerformanceExport', // 咨询报表-校区前期业绩报表导出
    48: 'schoolConsultationPerformanceStatisticsExport', // 咨询报表-校区咨询师业绩统计导出

    49: 'schoolAfterExport', // 学管-校区后期业绩统计
    50: 'studentHoursExport', // 学管-学生课时量导出
    51: 'schoolStudentExport', // 学管-校区学生导出
    52: 'classHoursExport', // 学管-学管学生课时汇总导出
    53: 'managerStudentExport', // 学管-学管管理学员导出
    54: 'perExport', // 学管-学管师业绩导出
    55: 'schoolSignSituationStatisticsExport', // 教务报表-校区课签情况统计导出

    56: 'unitPriceExport', // 校区课时单价接口导出
    57: 'branchOrSchoolExport', // 校区/公司业绩报表导出57
    58: 'completionRateExport', // 校区/公司完成率导出58
    59: 'studentsDistributedExport', // 校区学员分布统计接口导出59
    60: 'schoolStudentStatExport', // 校区学生统计导出60
    61: 'contractComparisonExport', // 签约同期对比导出61
    62: 'signedComparisonExport', // 课收同期对别导出62
    63: 'getBalanceTransferExport', // 转余额导出63
    64: 'autoMaticIncomeExport', // 财务收入明细导出64
    65: 'teacherClassSignExport', // 教师课签明细导出65
    66: 'studentClassSignExport', // 学生课签明细导出66
    67: 'getStudentSignInfoAndItsInfoBySchoolExport', // its课签明细导出67
    68: 'introductionStudentExport', // 转介绍导出68
    69: 'customerVisitExport', //客户上门管理导出69

    70: 'jdxkStudentExport', //教学报表-精雕细课学生统计表（学生）导出70
    71: 'jdxkTeacherExport', //教学报表-精雕细课统计表（老师）导出71
    72: 'jdxkListExportt', //精雕细课推送记录导出72
    73: 'superClassTeacherSigningDetailsExport', // 超课教师课签明细导出73
    74: 'superClassStudentSigningDetailsExport', //超课学生课签明细导出74
    75: 'systemSubjectGroupExport', //学科组成员导出75
    76: 'studentExport', //学生列表导出76
    77: 'teacherTeamExport', //教师班课课时统计列表导出77
    78: 'managementTeamExport', //学管班课课时统计列表导出78
    79: 'getSchoolAllTimeTableExport', //教务中心-校区排课的列表导出79
    80: 'channelExport', //导出所有渠道
    81: 'studentsPushListExport', //学情信息精雕细课导出
    82: 'getStudentSubjectGuideExceExport', //TS学生学科导图导出excel
    83: 'studyListExport', //精雕细课学习数据 - 导出
    84: 'getAchievementExport', //成绩 - 导出
    85: 'completionRateRealExport', //实时报表完成率 - 导出
    86: 'branchOrSchoolRealExport', //实时报表业绩 - 导出
    87: 'classOpenLogExport', //开班记录 - 导出
    88: 'getReplicateTimeTableLogDetailsExport', //尅表日志 - 导出
    89: 'changeRecordExport', //学生状态日志 - 导出
    90: 'exportStatistics', //学生成绩统计 - 导出
    91: 'orderRebateExport', //返利充值订单-导出

}

export default load



// WEBPACK FOOTER //
// ./src/components/downLoad.js